<template>
	<span :class="{ linked: linked }">
		<span v-for="(label, labelIndex) in labels" :key="'label-' + labelIndex" :class="{ wrap: true, disabled: disabled }">
			<span v-if="labelIndex > 0">, </span
			><span :class="{ match: label.match, new: isNew }"
				>{{ label.label }}<span class="is-match" v-if="!!label.match && !disabled && !label.rough">It's a match!</span
				><span class="is-match" v-if="!!label.match && !disabled && label.rough">Meets your minimum requirement</span></span
			> </span
		><span v-if="leftOver > 0"
			>, <span class="left-over">+{{ leftOver }} more</span></span
		>
	</span>
</template>

<script>
import { computed } from "vue";

export default {
	name: "BrandLabel",
	props: {
		fieldName: {
			type: String,
		},
		brand: {
			type: Object,
		},
		matchBrand: {
			type: Object,
		},
		append: {
			type: String,
			default: "",
		},
		prepend: {
			type: String,
			default: "",
		},
		settings: {
			type: Object,
			default: () => {},
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		full: {
			type: Boolean,
			default: false,
		},
		shortenSocial: {
			type: Boolean,
			default: true,
		},
		linked: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const isNew = computed(() => {
			if (props.settings && Object.keys(props.settings).length > 0) {
				return !!props.settings.new;
			}
			return true;
		});

		const isSocial = computed(() => {
			return ["instagram_followers", "facebook_followers", "tiktok_followers", "email_database"].indexOf(props.fieldName) > -1;
		});

		const formatSocialLabel = (label) => {
			const parts = label.split(" - ");
			if (parts.length !== 2) return label;

			const parseNum = (str) => parseInt(str.replace(/,/g, ""), 10);
			const numA = parseNum(parts[0]);
			const numB = parseNum(parts[1]);

			if (isNaN(numA) || isNaN(numB)) return label;

			if (numB < 100_000 && numA < 100_000) return label;

			if (numB >= 1_000_000 || numA >= 1_000_000) {
				const toM = (n) => {
					const m = n / 1_000_000;
					return parseFloat(m.toFixed(2)).toString();
				};
				return `${toM(numA)} - ${toM(numB)} million`;
			}

			if (numB >= 1_000 || numA >= 1_000) {
				const toK = (n) => {
					if (n >= 1_000) {
						const k = n / 1_000;
						return parseFloat(k.toFixed(1)).toString() + "K";
					}
					return n.toString();
				};
				return `${toK(numA)} - ${toK(numB)}`;
			}

			return label;
		};

		const na = computed(() => {
			return (
				isSocial.value &&
				props.matchBrand &&
				props.matchBrand["partner_brand_" + props.fieldName] &&
				props.matchBrand["partner_brand_" + props.fieldName].length &&
				props.matchBrand["partner_brand_" + props.fieldName][0] < 0
			);
		});

		const labels = computed(() => {
			const b = props.settings && Object.keys(props.settings).length > 0 ? props.settings : props.brand ? props.brand[props.fieldName] : null;

			if (!b || !b.label || !Array.isArray(b.label)) {
				return [];
			}

			let resultLabels = [];
			let max = props.full ? b.label.length : 5;
			let matchCount = 0;
			let ops = [];

			if (!props.full) {
				b.label.forEach((label) => {
					if (label.match) matchCount++;
				});

				let noMatchAllowed = max - matchCount;

				b.label.forEach((label) => {
					if (label.match) {
						ops.push(label);
					} else if (noMatchAllowed > 0) {
						ops.push(label);
						noMatchAllowed--;
					}
				});
			} else {
				ops = b.label;
			}

			ops.forEach((label) => {
				const rawLabel = isSocial.value && props.shortenSocial ? formatSocialLabel(label.label) : label.label;
				resultLabels.push({
					label: rawLabel + (props.append ? " " + props.append : ""),
					match: !na.value && !!label.match,
					rough: !!label.rough,
				});
			});

			return resultLabels;
		});

		const leftOver = computed(() => {
			const b = props.settings && Object.keys(props.settings).length > 0 ? props.settings : props.brand ? props.brand[props.fieldName] : null;
			if (!b || !b.label) return 0;
			return b.label.length - labels.value.length;
		});

		return {
			isNew,
			leftOver,
			isSocial,
			na,
			labels,
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_helper.less";
@import "./../../assets/css/less/_settings.less";
.match {
	&.new {
		font-weight: @bold;
	}
}
span {
	&.linked {
		cursor: pointer;
		span {
			cursor: pointer !important;
		}
	}
}
.wrap {
	&:not(.disabled) {
		.match {
			color: @formDefaultColour;
			position: relative;
			cursor: default;
			font-weight: @bold;
			.is-match {
				font-size: 0.8em;
				background-color: @formDefaultColour;
				position: absolute;
				color: white;
				.rounded(@radiusSm);
				display: none;
				top: -1.6em;
				right: 0;
				width: 80px;
				text-align: center;
				left: 50%;
				margin-left: -40px;
			}
			&:hover {
				.is-match {
					display: block;
				}
			}
		}
	}
}
</style>